import { SEATERS_COMMIT_HASH, TranslationsQuery } from '@seaters/constants';

export const fetchTranslations = async (
  params: TranslationsQuery
): Promise<Record<string, string>> => {
  const path = `/translations/${params.target.toLowerCase()}/${params.lang}.json`;
  const result = await fetch(`${path}?v=${SEATERS_COMMIT_HASH}`);

  if (!result.ok) {
    throw new Error(
      `Failed to fetch ${path}: ${result.status} ${result.statusText}`
    );
  }

  // A missing namespace/locale does not reliably 404 — both the dev server and
  // the deployed SPA answer 200 with index.html — so an ok status is not proof
  // the body is the file we asked for. Parse it ourselves to name the URL that
  // is actually missing instead of surfacing an opaque syntax error.
  const body = await result.text();

  try {
    return JSON.parse(body) as Record<string, string>;
  } catch {
    throw new Error(
      `Failed to fetch ${path}: ${result.status} response was not JSON`
    );
  }
};
